import { addClass, removeClass } from "@pod-point/dom-ops";

let instances = [];
const IS_ACTIVE = "is-active";

class Tabs {
    /**
     * Binding our event listener to the tabs.
     *
     * @param {HTMLElement} element
     */
    constructor(element) {
        this.element = element;

        this.tabs = this.element.querySelectorAll(".tabs__tab");

        this.bindEvents();
    }

    /**
     * Adds on change event listener.
     *
     * @return {void}
     */
    bindEvents() {
        this.tabs.forEach((tab) => {
            tab.addEventListener("click", () => {
                const tabId = tab.getAttribute("id");
                const tabBody = this.element.querySelector(`#tab-body-${tabId}`);

                this.toggle(tab, tabBody);
            });
        });
    }

    /**
     * Toggle the selected tab and tab body.
     *
     * @param {HTMLElement} tab
     * @param {HTMLElement} tabBody
     * @return {void}
     */
    toggle(tab, tabBody) {
        const activeElements = this.element.querySelectorAll(`.${IS_ACTIVE}`);

        if (activeElements.length) {
            activeElements.forEach((element) => removeClass(element, IS_ACTIVE));
        }

        addClass(tab, IS_ACTIVE);
        addClass(tabBody, IS_ACTIVE);
    }
}

export default {
    init: (element) => {
        instances.push(new Tabs(element));
    },

    destroy: () => {
        instances.forEach((instance) => instance.unbindEvents());
        instances = [];
    },
};
